module.exports = __webpack_public_path__ + "static/media/sssss.3c8653ed.png";